import React from "react";
import { RevealOnScroll } from "../shared";
import TierComparisonTable from "@/pages/PartnerDashboard/components/TierComparisonTable";

const TiersSection = () => (
  <section id="tiers" className="section-padding mesh-gradient relative overflow-hidden" data-testid="tiers-section">
    <div className="max-w-5xl mx-auto px-6 lg:px-8">
      <RevealOnScroll className="text-center mb-12">
        <span className="badge-mono text-partner-accent bg-[#00D2FF]/10 border border-[#00D2FF]/25 px-3 py-1.5 rounded-full inline-block mb-6">
          THE PROFIT MATRIX
        </span>
        <h2 className="text-3xl sm:text-4xl font-bold mb-4 leading-tight">
          Infrastructure Deployment <span className="gradient-text">Tiers</span>
        </h2>
        <p className="text-partner-muted font-body max-w-2xl mx-auto leading-relaxed">
          Don't look at this as software cost. Look at this as unutilized space inside your existing client contracts. Match your clients with the infrastructure tiers below and unlock immediate recurring revenue.
        </p>
      </RevealOnScroll>

      <RevealOnScroll delay={0.1}>
        <TierComparisonTable />
        <p className="text-center text-xs text-partner-muted font-body mt-6">
          Credits pool across your agency roster
        </p>
      </RevealOnScroll>
    </div>
  </section>
);

export default TiersSection;
